export const Orders: { [key: string]: string } = {
  ASC: 'ASC',
  DESC: 'DESC',
}
export type SortingOrder = keyof typeof Orders
export const SORTABLE_FIELD = {
  established: 'established',
  ipoed: 'ipoed',
  employees: 'employees',
  lastFundraised: 'lastFundraised',
  updated: 'updated',
  created: 'created',
  totalFunding: 'totalFunding',
  valuation: 'valuation',
  firstInterviewDate: 'firstInterviewDate',
}
export type SortableField = keyof typeof SORTABLE_FIELD

export function isSortableField(field: string): field is SortableField {
  return Object.keys(SORTABLE_FIELD).includes(field)
}

export function isSortingOrder(sort: string | number): sort is SortingOrder {
  return !!Orders[sort]
}
